/*//////////////////////*/
/* Imports
/*//////////////////////*/
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import App from "./App";
import { store } from "./store/store";


/*//////////////////////*/
/* Variables
/*//////////////////////*/
const root = ReactDOM.createRoot(document.getElementById("root"));
const persistor = persistStore(store);


/*//////////////////////*/
/* Render
/*//////////////////////*/
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
